import React from "react";

const WFIRSSQuestion4 = ({ questions, renderRadioInputs, questionKey }) => (
  <div key={`WFIRSSQuestion4${questionKey}`}>
    <div className="wfirs-progress-row">
      <div className="wfirs-progress-bar">
        <div style={{ width: "57.1%" }}></div>
      </div>
      <span className="wfirs-counter">4 / 7</span>
    </div>
    <h2 className="wfirs-section-title">Click the number for the rating that best describes how your emotional or behavioral problems have affected your Child and School Activities.</h2>
    {questions.slice(29, 41).map((question, index) => (
      <div className="wfirs-question" key={index}>
        <label className="wfirs-q-label">{index + 30}. {question.questions}</label>
        {renderRadioInputs(index + 30)}
      </div>
    ))}
  </div>
);

export default WFIRSSQuestion4;
